import { gql, useMutation } from '@apollo/client'
import toast from 'react-hot-toast'
import Button from 'components/Button'

export default function SalesCommissionReport(): JSX.Element {
  const [salesCommissionReport, { loading }] = useMutation(SalesCommissionReport.mutation, {
    onCompleted: () => {
      toast.success('Sent report to email. PLease note this may take a few minutes')
    },
    onError: (error) => {
      console.log({ error })
      toast.error('Error. Could not send report.')
    }
  })

  const onSubmit = async () => {
    await salesCommissionReport()
  }

  return (
    <Button colorScheme="black" variant="primary" onClick={onSubmit} disabled={loading}>
      {loading ? 'Sending...' : 'Sales Commission Report'}
    </Button>
  )
}

SalesCommissionReport.mutation = gql`
  mutation salesCommissionReport {
    salesCommissionReport
  }
`
